import React, { useState, useEffect } from "react";
import CustomICTooltip from "../Utility/Helpers/CustomICToolTip";
import { NOFOUrlGenerator } from "../Utility/Helpers/sitewide";
import InformationToolTip from "../Utility/Helpers/InformationToolTip";
import { Parser } from "html-to-react";

function TableDataView({
  data,
  fetchData,
  tabType,
  query,
  InformationToolTipOptions,
  fullName,
  recordAction,
  date_utc_options,
}) {
  const [sortDirection, setSortDirection] = useState("desc");
  const [sort, setSort] = useState("reldate");

  useEffect(() => {
    if (query && query !== "") {
      setSort("_score");
    }
  }, [query]);

  let handleSort = (sortOption) => {
    let temp_sort_diretion = sortDirection;
    if (sortDirection === "asc") {
      temp_sort_diretion = "desc";
    } else {
      temp_sort_diretion = "asc";
    }
    setSortDirection(temp_sort_diretion);
    setSort(sortOption);
    let updateDataQuery = {
      sort: sortOption + ":" + temp_sort_diretion,
    };
    recordAction("Sort", sortOption + ":" + temp_sort_diretion);
    fetchData(updateDataQuery);
  };
  return (
    <div className="table-container">
      <table className="table table-striped border table-bordered responsive-table">
        <thead className="table-secondary align-middle">
          <tr>
            <th
              onClick={() => {
                handleSort("title.aggs");
              }}
            >
              <div className="d-inline-flex flex-nowrap justify-content-between text-nowrap w-100">
                <span>Title</span>
                {sort === "title.aggs" ? (
                  sortDirection === "asc" ? (
                    <span className="cursor-pointer">&#x25B2;</span>
                  ) : (
                    <span className="cursor-pointer">&#x25BC;</span>
                  )
                ) : (
                  ""
                )}
              </div>
            </th>
            <th
              onClick={() => {
                handleSort("parentIC.aggs");
              }}
            >
              <div className="d-inline-flex flex-nowrap justify-content-between text-nowrap w-100">
                <span>
                  Issuing <br />
                  Organization
                  <InformationToolTip
                    content={InformationToolTipOptions.issuingOrg}
                  />
                </span>
                {sort === "parentIC.aggs" ? (
                  sortDirection === "asc" ? (
                    <span className="cursor-pointer">&#x25B2;</span>
                  ) : (
                    <span className="cursor-pointer">&#x25BC;</span>
                  )
                ) : (
                  ""
                )}
              </div>
            </th>
            <th
              onClick={() => {
                handleSort("sponsors.aggs");
              }}
            >
              <div className="d-inline-flex flex-nowrap justify-content-between text-nowrap w-100">
                <span>
                  Participating
                  <br />
                  Organization(s)
                  <InformationToolTip
                    content={InformationToolTipOptions.partOrgs}
                  />
                </span>
                {sort === "sponsors.aggs" ? (
                  sortDirection === "asc" ? (
                    <span className="cursor-pointer">&#x25B2;</span>
                  ) : (
                    <span className="cursor-pointer">&#x25BC;</span>
                  )
                ) : (
                  ""
                )}
              </div>
            </th>
            {tabType === "foa" && (
              <th
                onClick={() => {
                  handleSort("ac.aggs");
                }}
              >
                <div className="d-inline-flex flex-nowrap justify-content-between text-nowrap w-100">
                  <span>
                    Activity
                    <br />
                    Codes
                    <InformationToolTip
                      content={InformationToolTipOptions.activityCodes}
                    />
                  </span>
                  {sort === "ac.aggs" ? (
                    sortDirection === "asc" ? (
                      <span className="cursor-pointer">&#x25B2;</span>
                    ) : (
                      <span className="cursor-pointer">&#x25BC;</span>
                    )
                  ) : (
                    ""
                  )}
                </div>
              </th>
            )}

            <th
              onClick={() => {
                handleSort("reldate");
              }}
            >
              <div className="d-inline-flex flex-nowrap justify-content-between text-nowrap w-100">
                <span>
                  Release
                  <br />
                  Date{" "}
                  <InformationToolTip
                    content={InformationToolTipOptions.releaseDate}
                  />
                </span>
                {sort === "reldate" ? (
                  sortDirection === "asc" ? (
                    <span className="cursor-pointer">&#x25B2;</span>
                  ) : (
                    <span className="cursor-pointer">&#x25BC;</span>
                  )
                ) : (
                  ""
                )}
              </div>
            </th>
            <th
              onClick={() => {
                handleSort("expdate");
              }}
            >
              <div className="d-inline-flex flex-nowrap justify-content-between text-nowrap w-100">
                <span>
                  Expiration
                  <br />
                  Date{" "}
                  <InformationToolTip
                    content={InformationToolTipOptions.expirationDate}
                  />
                </span>
                {sort === "expdate" ? (
                  sortDirection === "asc" ? (
                    <span className="cursor-pointer">&#x25B2;</span>
                  ) : (
                    <span className="cursor-pointer">&#x25BC;</span>
                  )
                ) : (
                  ""
                )}
              </div>
            </th>
            <th
              onClick={() => {
                handleSort("docnum.aggs");
              }}
            >
              <div className="d-inline-flex flex-nowrap justify-content-between text-nowrap w-100">
                <span>
                  Grants.gov
                  <br />
                  Record
                  <InformationToolTip content={InformationToolTipOptions.gg} />
                </span>

                {sort === "docnum.aggs" ? (
                  sortDirection === "asc" ? (
                    <span className="cursor-pointer">&#x25B2;</span>
                  ) : (
                    <span className="cursor-pointer">&#x25BC;</span>
                  )
                ) : (
                  ""
                )}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((foa, index) => {
            return (
              <tr key={index + "-t-key"}>
                <td>
                  {foa.highlight && foa.highlight.title
                    ? Parser().parse(foa.highlight.title.join())
                    : Parser().parse(foa._source.title)}
                </td>

                <td>
                  <CustomICTooltip
                    ic={foa._source.primaryIC}
                    name={fullName(foa._source.primaryIC)}
                  />
                </td>
                <td>
                  {(() => {
                    // Check if primary IC is NIH Common Fund related
                    const isPrimaryCommonFund = [
                      "RMOD",
                      "OSC",
                      "Roadmap",
                    ].includes(foa._source.primaryIC);

                    // Filter out NIH Common Fund related ICs from sponsors if primary is Common Fund
                    const filteredSponsors =
                      isPrimaryCommonFund && foa._source.sponsors
                        ? foa._source.sponsors.filter(
                            (spons) =>
                              !["RMOD", "OSC", "Roadmap"].includes(spons),
                          )
                        : foa._source.sponsors;

                    // Check if we have valid sponsors to display
                    if (
                      filteredSponsors &&
                      filteredSponsors.length > 0 &&
                      filteredSponsors[0] !== "none"
                    ) {
                      return filteredSponsors.map((spons, index) => {
                        return index === filteredSponsors.length - 1 ? (
                          <CustomICTooltip
                            ic={spons}
                            name={fullName(spons)}
                            key={index + "-tookey"}
                          />
                        ) : (
                          <>
                            <CustomICTooltip
                              ic={spons}
                              name={fullName(spons)}
                              key={index + "-tookey"}
                            />
                            ,{" "}
                          </>
                        );
                      });
                    }
                    return "N/A";
                  })()}
                </td>
                {tabType === "foa" && (
                  <td>
                    {foa._source.ac
                      ? foa._source.ac.map((ac, index) => {
                          return index === foa._source.ac.length - 1 ? (
                            <span key={index + "-ackey"}>{ac}</span>
                          ) : (
                            <span key={index + "-ackey"}>{ac}, </span>
                          );
                        })
                      : "N/A"}
                  </td>
                )}
                <td>
                  {foa._source.reldate
                    ? new Intl.DateTimeFormat("en-US", date_utc_options).format(
                        new Date(foa._source.reldate),
                      )
                    : "N/A"}
                </td>
                <td>
                  {foa._source.expdate
                    ? new Intl.DateTimeFormat("en-US", date_utc_options).format(
                        new Date(foa._source.expdate),
                      )
                    : "N/A"}
                </td>

                <td>
                  <a
                    href={
                      foa._source.ggid
                        ? "https://simpler.grants.gov/opportunity/" +
                          foa._source.ggid
                        : NOFOUrlGenerator(foa._source.filename)
                    }
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => {
                      recordAction("NOFO Click", foa._source.docnum);
                    }}
                  >
                    {foa._source.docnum}
                  </a>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default TableDataView;
